import { render, staticRenderFns } from "./KeyMappingDialog.vue?vue&type=template&id=2db10f7f&scoped=true"
import script from "./KeyMappingDialog.vue?vue&type=script&lang=js"
export * from "./KeyMappingDialog.vue?vue&type=script&lang=js"
import style0 from "./KeyMappingDialog.vue?vue&type=style&index=0&id=2db10f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db10f7f",
  null
  
)

export default component.exports